import React, { useEffect, useState } from "react";
import { useLoader } from "../../../../base/context/LoaderProvider";
import {
  ToastTypes,
  useMessage,
} from "../../../../base/context/MessageProvider";
import { orderApiService } from "../../../../service/seller/orderApiService";
import { useParams, useNavigate } from "react-router-dom";
import ProductOrderTable from "../../../../component/views/admin/orderDetails/productOrderTable";
import OrderInfo from "../../../../component/views/admin/orderDetails/orderInfo";
import OrderTracking from "../../../../component/views/admin/orderDetails/orderTracking";
import AdminRaiseTicketModal from "../../../../component/views/admin/orderManagement/raiseTicketModal";
import TicketChatPanel from "../../../../component/library/ticketChatPanel";
import EditOrderModal from "../../../../component/views/admin/orderDetails/editOrderModal";
import "./style.css";

export default function OrderDetails() {
  const [data, setData] = useState({});
  const [consumerPrice, setConsumerPrice] = useState(0);
  const [upsaleoPrice, setUpsaleoPrice] = useState(0);
  const [ticketModalOpen, setTicketModalOpen] = useState(false);
  const [ticketPanelTicketId, setTicketPanelTicketId] = useState(null);
  const [ticketPanelOrderLabel, setTicketPanelOrderLabel] = useState(null);
  const [editModalOpen, setEditModalOpen] = useState(false);

  const loader = useLoader();
  const params = useParams();
  const navigate = useNavigate();
  const message = useMessage();

  const getOrderById = () => {
    loader.showLoading(true);
    orderApiService
      .getOrderById(params.id)
      .then((res) => {
        loader.showLoading(false);
        if (res.status.code === 200) {
          setData(res.data);
        } else {
          message.showToast(res.error.message, ToastTypes.ERROR);
        }
      })
      .catch((err) => {
        loader.showLoading(false);
        message.showToast(err?.message || "Server error. Try again later", ToastTypes.ERROR);
      });
  };

  useEffect(() => {
    getOrderById();
  }, []);

  useEffect(() => {
    const cPrice = data?.orderDetails?.reduce(
      (sum, item) => sum + (item.consumerPrice || 0),
      0
    );

    const uPrice = data?.orderDetails?.reduce(
      (sum, item) => sum + (item.product?.sp || 0),
      0
    );

    setConsumerPrice(cPrice);
    setUpsaleoPrice(uPrice);
  }, [data]);

  const hasTicket = data?.ticket && data?.ticketId;

  return (
    <div className="order_detail_bg">
      <div className="order_detail_actions">
        <button
          type="button"
          className="order_detail_back_btn"
          onClick={() => navigate("/admin/order-management")}
        >
          <i className="fas fa-arrow-left" style={{ marginRight: "6px" }} />
          Back to orders
        </button>
        <div className="order_detail_ticket_actions">
          <button
            type="button"
            className="order_detail_edit_btn"
            onClick={() => setEditModalOpen(true)}
          >
            <i className="fas fa-edit" style={{ marginRight: "6px" }} />
            Edit
          </button>
          {hasTicket ? (
            <button
              type="button"
              className="order_detail_view_ticket_btn"
              onClick={() => {
                setTicketPanelTicketId(data.ticketId);
                setTicketPanelOrderLabel(data.upsaleoOrderId || null);
              }}
            >
              <i className="fas fa-ticket-alt" style={{ marginRight: "6px" }} />
              View ticket
            </button>
          ) : (
            <button
              type="button"
              className="order_detail_raise_ticket_btn"
              onClick={() => setTicketModalOpen(true)}
            >
              <i className="fas fa-plus" style={{ marginRight: "6px" }} />
              Raise ticket
            </button>
          )}
        </div>
      </div>

      <OrderInfo data={data} />
      <OrderTracking data={data} />
      <ProductOrderTable data={data} />

      {ticketModalOpen && data?._id && (
        <AdminRaiseTicketModal
          modalIsOpen={ticketModalOpen}
          setIsOpen={setTicketModalOpen}
          orderId={data._id}
          handleRefresh={getOrderById}
        />
      )}

      {ticketPanelTicketId && (
        <TicketChatPanel
          ticketId={ticketPanelTicketId}
          orderLabel={ticketPanelOrderLabel}
          onClose={() => {
            setTicketPanelTicketId(null);
            setTicketPanelOrderLabel(null);
          }}
        />
      )}

      {editModalOpen && data?._id && (
        <EditOrderModal
          data={data}
          onClose={() => setEditModalOpen(false)}
          onSaved={getOrderById}
        />
      )}
    </div>
  );
}
